module.exports = __webpack_public_path__ + "static/media/bongacams.445a4433.png";